import type * as Types from '../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { MatFieldsFragmentDoc } from '../../graphql/gql-fragments/meeting-agenda-template.graphql';
import { MatiFieldsFragmentDoc } from '../../graphql/gql-fragments/meeting-agenda-template-item.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlBoardMeetingTemplatesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GqlBoardMeetingTemplatesQuery = { meetingAgendaTemplates: Array<{ id: string, name: string, isDefault: boolean, companyId: string, createdAt: string, updatedAt: string, meetingAgendaTemplateItems: Array<{ id: string, order: number, subjectPrimaryLang: string, subjectSecondaryLang: string, commentPrimaryLang?: string | null, commentSecondaryLang?: string | null, decisionPrimaryLang?: string | null, decisionSecondaryLang?: string | null, mandatory: boolean, firstGroup: boolean, lastGroup: boolean, kind: Types.GqlAgendaItemKind, meetingAgendaTemplateId: string, createdAt: string, updatedAt: string }> }> };

export type GqlCreateMeetingAgendaTemplateMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlMatCreateInput;
}>;


export type GqlCreateMeetingAgendaTemplateMutation = { matCreate: Array<{ id: string, name: string, isDefault: boolean, companyId: string, createdAt: string, updatedAt: string, meetingAgendaTemplateItems: Array<{ id: string, order: number, subjectPrimaryLang: string, subjectSecondaryLang: string, commentPrimaryLang?: string | null, commentSecondaryLang?: string | null, decisionPrimaryLang?: string | null, decisionSecondaryLang?: string | null, mandatory: boolean, firstGroup: boolean, lastGroup: boolean, kind: Types.GqlAgendaItemKind, meetingAgendaTemplateId: string, createdAt: string, updatedAt: string }> }> };


export const BoardMeetingTemplatesDocument = gql`
    query BoardMeetingTemplates($companyId: ID!) {
  meetingAgendaTemplates(companyId: $companyId) {
    ...MatFields
    meetingAgendaTemplateItems {
      ...MatiFields
    }
  }
}
    ${MatFieldsFragmentDoc}
${MatiFieldsFragmentDoc}`;

/**
 * __useBoardMeetingTemplatesQuery__
 *
 * To run a query within a React component, call `useBoardMeetingTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardMeetingTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardMeetingTemplatesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useBoardMeetingTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GqlBoardMeetingTemplatesQuery, GqlBoardMeetingTemplatesQueryVariables> & ({ variables: GqlBoardMeetingTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlBoardMeetingTemplatesQuery, GqlBoardMeetingTemplatesQueryVariables>(BoardMeetingTemplatesDocument, options);
      }
export function useBoardMeetingTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlBoardMeetingTemplatesQuery, GqlBoardMeetingTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlBoardMeetingTemplatesQuery, GqlBoardMeetingTemplatesQueryVariables>(BoardMeetingTemplatesDocument, options);
        }
export function useBoardMeetingTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlBoardMeetingTemplatesQuery, GqlBoardMeetingTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlBoardMeetingTemplatesQuery, GqlBoardMeetingTemplatesQueryVariables>(BoardMeetingTemplatesDocument, options);
        }
export type BoardMeetingTemplatesQueryHookResult = ReturnType<typeof useBoardMeetingTemplatesQuery>;
export type BoardMeetingTemplatesLazyQueryHookResult = ReturnType<typeof useBoardMeetingTemplatesLazyQuery>;
export type BoardMeetingTemplatesSuspenseQueryHookResult = ReturnType<typeof useBoardMeetingTemplatesSuspenseQuery>;
export type BoardMeetingTemplatesQueryResult = Apollo.QueryResult<GqlBoardMeetingTemplatesQuery, GqlBoardMeetingTemplatesQueryVariables>;
export const CreateMeetingAgendaTemplateDocument = gql`
    mutation CreateMeetingAgendaTemplate($companyId: ID!, $input: MatCreateInput!) {
  matCreate(companyId: $companyId, input: $input) {
    ...MatFields
    meetingAgendaTemplateItems {
      ...MatiFields
    }
  }
}
    ${MatFieldsFragmentDoc}
${MatiFieldsFragmentDoc}`;
export type GqlCreateMeetingAgendaTemplateMutationFn = Apollo.MutationFunction<GqlCreateMeetingAgendaTemplateMutation, GqlCreateMeetingAgendaTemplateMutationVariables>;

/**
 * __useCreateMeetingAgendaTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMeetingAgendaTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingAgendaTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingAgendaTemplateMutation, { data, loading, error }] = useCreateMeetingAgendaTemplateMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeetingAgendaTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateMeetingAgendaTemplateMutation, GqlCreateMeetingAgendaTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateMeetingAgendaTemplateMutation, GqlCreateMeetingAgendaTemplateMutationVariables>(CreateMeetingAgendaTemplateDocument, options);
      }
export type CreateMeetingAgendaTemplateMutationHookResult = ReturnType<typeof useCreateMeetingAgendaTemplateMutation>;
export type CreateMeetingAgendaTemplateMutationResult = Apollo.MutationResult<GqlCreateMeetingAgendaTemplateMutation>;
export type CreateMeetingAgendaTemplateMutationOptions = Apollo.BaseMutationOptions<GqlCreateMeetingAgendaTemplateMutation, GqlCreateMeetingAgendaTemplateMutationVariables>;